import ProductsContainer from "../../container/admin/products";

const ProductsView = () => {
    return <ProductsContainer />;
};

export default ProductsView; 